import React from 'react';
import './error.css';
import { KID_1 } from '../../utils/constants/images';

function NotFoundPage() {
    return (
        <div className="error-container">
            <img src={KID_1} alt="Not Found" className="error-image" />
            <h1>404 - Not Found</h1>
            <p>The page you are looking for does not exist.</p>
        </div>
    );
}

export default NotFoundPage;